"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateClientDTO = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const ClientDTO_1 = require("./ClientDTO");
const ClientCommentDTO_1 = require("./ClientCommentDTO");
const InitialClientAddresses_1 = require("./InitialClientAddresses");
class CreateClientDTO {
}
exports.CreateClientDTO = CreateClientDTO;
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => ClientDTO_1.ClientDTO),
    __metadata("design:type", Object)
], CreateClientDTO.prototype, "client", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => ClientCommentDTO_1.ClientCommentDTO),
    __metadata("design:type", ClientCommentDTO_1.ClientCommentDTO)
], CreateClientDTO.prototype, "initialComment", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => InitialClientAddresses_1.InitialClientAddresses),
    __metadata("design:type", InitialClientAddresses_1.InitialClientAddresses)
], CreateClientDTO.prototype, "initialAddresses", void 0);
